import { 
  FaGithub, 
  FaJava, 
  FaReact, 
  FaDocker, 
  FaPython, 
  FaGit, 
  FaLinkedin,
  FaLinux,
  FaServer
} from "react-icons/fa";
import { 
  SiSpringboot, 
  SiPostgresql, 
  SiRabbitmq, 
  SiJavascript, 
  SiReact,
  SiKubernetes,
  SiMongodb,
  SiMysql,
  SiPostman
} from "react-icons/si";

export const commonData = {
  personal: {
    name: "Burak Karahan",
    title: "Yazılım Mühendisi",
    email: "brkkarahan288@gmail.com",
    location: "İstanbul, Türkiye",
    website: "https://www.devburakkarahan.com",
    linkedin: "https://www.linkedin.com/in/burak-karahan-54a86b250/",
    github: "https://github.com/BurakKarahan8",
  },
  skills: [
    { name: "Java", icon: <FaJava color="#e76f00" /> },
    { name: "Spring Boot", icon: <SiSpringboot color="#6db33f" /> },
    { name: "Microservices", icon: <FaServer color="#b8bb26" /> },
    { name: "PostgreSQL", icon: <SiPostgresql color="#336791" /> },
    { name: "Docker", icon: <FaDocker color="#0db7ed" /> },
    { name: "Kubernetes", icon: <SiKubernetes color="#326ce5" /> },
    { name: "Linux", icon: <FaLinux color="#fcc624" /> },
    { name: "RabbitMQ", icon: <SiRabbitmq color="#ff6600" /> },
    { name: "MySQL", icon: <SiMysql color="#4479a1" /> },
    { name: "MongoDB", icon: <SiMongodb color="#47a248" /> },
    { name: "Python", icon: <FaPython color="#3776ab" /> },
    { name: "React", icon: <FaReact color="#61dafb" /> },
    { name: "React Native", icon: <SiReact color="#61dafb" /> },
    { name: "Postman", icon: <SiPostman color="#ff6c37" /> },
    { name: "Git & GitHub", icon: <FaGit color="#dd3b1e" /> },
    { name: "JavaScript", icon: <SiJavascript color="#f7df1e" /> },
  ]
};

export const content = {
  tr: {
    navbar: {
      home: "Ana Sayfa",
      experience: "Deneyim",
      education: "Eğitim",
      projects: "Projeler",
      contact: "İletişim",
      toggle: "EN"
    },
    hero: {
      greeting: "MERHABA, BEN",
      title: "Yazılım Mühendisi & Backend Developer",
      about: "Uçtan uca mobil ve web uygulamaları ile bu uygulamaları destekleyen sunucu altyapıları geliştiriyorum. Yazılım mimarisi, API tasarımı, backend geliştirme ve Linux sistem yönetimi yetkinliklerimi harmanlayarak, kodun tasarımından canlı ortama taşınmasına kadarki tüm teknik süreçleri bütüncül bir mühendislik yaklaşımıyla yönetiyorum. Yüksek performanslı, ölçeklenebilir ve kullanıcı odaklı modern projeler inşa ediyorum.",
      status_prefix: "Şu an:",
      status_text: "Spring Boot & Microservices",
      status_suffix: "üzerine çalışıyor",
      btn_cv: "CV İndir",
      btn_projects: "Projeleri Gör"
    },
    sections: {
      skills: "Teknoloji Yığınım",
      experience: "İş Deneyimi",
      education: "Eğitim Bilgisi",
      projects: "Öne Çıkan Projeler",
      contact_title: "İletişime Geç",
      contact_subtitle: "Projeleriniz, iş birliği teklifleriniz veya sadece merhaba demek için bana ulaşabilirsiniz.",
      contact_form_name: "Adınız Soyadınız",
      contact_form_email: "E-posta Adresiniz",
      contact_form_msg: "Mesajınız",
      contact_btn: "Gönder",
      contact_sending: "Gönderiliyor...",
      contact_sent: "Gönderildi!",
      footer: "© 2026 Burak Karahan. Tüm hakları saklıdır."
    },
    experience: [
      {
        company: "Fibabanka",
        role: "Sistem Yönetimi Stajyeri",
        badge: "Uzun Dönem Stajı (6 ay)",
        date: "02/2026 – 07/2026",
        description: "Yazılım mimarilerinin üzerinde koştuğu Red Hat Linux tabanlı sunucuların yapılandırma ve operasyon süreçlerinde aktif görev aldım. Geliştirilen uygulamaların kesintisiz ve güvenli bir şekilde çalışabilmesi adına kurumsal yedekleme (backup) ve depolama (storage) altyapılarının yönetimine destek sağlayarak sistemlerin sürdürülebilirliğine katkıda bulundum.",
        tags: ["Red Hat Linux", "Sistem Yönetimi", "Backup & Storage", "Sunucu Operasyonu"]
      },
      {
        company: "Deka Teknoloji",
        role: "Backend Geliştirme Stajyeri",
        badge: "Yaz Stajı (2 ay)",
        date: "07/2025 – 09/2025",
        description: "Yazılım mimarisi ve API geliştirme yetkinliklerimi gerçek dünya projelerine taşıyarak backend ve veritabanı operasyonları üzerinde aktif olarak çalıştım. Bu süreçte algoritmik altyapımı sunucu taraflı geliştirmelerle harmanlayarak, uygulamaların performanslı ve ölçeklenebilir bir temelde çalışmasına doğrudan katkı sağladım.",
        tags: ["Backend Development", "API Tasarımı", "Veritabanı Yönetimi", "Mikroservis"]
      }
    ],
    education: [
      {
        school: "Fırat Üniversitesi",
        degree: "Lisans Eğitimi",
        field: "Yazılım Mühendisliği",
        status: "Mezun",
        gpa: "GNO: 3.31",
        date: "2022 – 2026",
        description: "Yazılım Mühendisliği lisans programından başarıyla mezun oldum. Yazılım mimarileri, veri yapıları, algoritmalar ve sistem tasarımı alanlarında kapsamlı akademik ve uygulamalı eğitim aldım."
      }
    ],
    projects: [
      {
        title: "RepVision",
        date: "11/2025 - Devam Ediyor",
        description: "Egzersiz videolarını Python (pose estimation) ile analiz eden ve video işleme akışını RabbitMQ üzerinden asenkron yöneten mobil bir platform inşa ettim. Veritabanı ve mesaj kuyruğu gibi tüm altyapı servislerini Docker üzerinde yapılandırdım.",
        tags: ["React Native", "Spring Boot", "RabbitMQ", "Python", "PostgreSQL", "Docker"],
        link: "https://github.com/BurakKarahan8/RepVision",
      },
      {
        title: "Digital Çarşı (E-Ticaret Platformu)",
        date: "07/2025 - 09/2025",
        description: "JWT yetkilendirmesi, kullanıcı rolleri ve e-posta doğrulaması barındıran, tek backend ve veritabanı entegrasyonuyla çalışan ölçeklenebilir bir platform kurdum. Gerçek dünya senaryolarına uygun bu yapıyı başarıyla ayağa kaldırdım.",
        tags: ["React", "Spring Boot", "PostgreSQL", "Docker", "JWT"],
        link: "https://github.com/BurakKarahan8/DigitalCarsi",
      },
      {
        title: "InternAI",
        date: "02/2025 - 06/2025",
        description: "Yapay zeka destekli otomatik CV ayrıştırma (parsing) ve staj ilanları yönetimi özelliklerine sahip kapsamlı bir kariyer platformu geliştirdim. Backend servislerini ve sistem mimarisini oluşturarak projenin hem web hem de mobil bileşenlerini başarıyla hayata geçirdim.",
        tags: ["React", "Spring Boot", "PostgreSQL", "AI Parsing"],
        link: "https://github.com/BurakKarahan8/InternAI",
      },
      {
        title: "Türkiye Yenilenebilir Enerji Analizi",
        date: "10/2024 - 01/2025",
        description: "Yenilenebilir enerji kaynaklarının coğrafi dağılımını PostgreSQL verileriyle analiz ederek harita üzerinde görselleştiren tam yığın (full-stack) bir uygulama yazdım.",
        tags: ["React", "Spring Boot", "PostgreSQL", "Data Vis"],
        link: "https://github.com/BurakKarahan8/Turkey-renewable-energy-analysis",
      }
    ],
    inexoPrivacy: {
      tag: "Resmi Hukuki Metin",
      printBtn: "Yazdır / PDF",
      title: "Gizlilik Politikası (Privacy Policy)",
      subtitle: "Inexo Finance Mobil Uygulaması İçin Veri Koruma ve Gizlilik Esasları",
      meta: {
        appLabel: "Uygulama Adı",
        appName: "Inexo Finance",
        packageLabel: "Paket Adı",
        packageId: "com.burakkarahan.inexo",
        developerLabel: "Geliştirici / Yayıncı",
        developerName: "Burak Karahan",
        updatedLabel: "Yürürlük / Son Güncelleme",
        updatedDate: "18 Ekim 2026"
      },
      complianceNotice: "Bu Gizlilik Politikası; Google Play Geliştirici Program Politikaları, Apple App Store İnceleme Kılavuzları, KVKK (Kişisel Verilerin Korunması Kanunu) ve GDPR gereksinimlerine tam uyumlu olarak hazırlanmıştır. Inexo Finance, finansal verileriniz için %100 çevrimdışı yerel depolama prensibiyle çalışır; gelir ve gider kayıtlarınız hiçbir harici sunucuya iletilmez.",
      tocTitle: "İçindekiler",
      toc: [
        { id: "sec-overview", label: "1.0 Genel Bakış ve Temel Felsefemiz" },
        { id: "sec-data", label: "2.0 Toplanan ve İşlenen Veriler" },
        { id: "sec-admob", label: "2.1 Reklam Hizmetleri (Google AdMob)" },
        { id: "sec-permissions", label: "3.0 İzinler ve Kullanım Amaçları" },
        { id: "sec-matrix", label: "4.0 Veri Güvenliği Beyan Tablosu" },
        { id: "sec-deletion", label: "5.0 Veri Güvenliği ve Silme Hakkı" },
        { id: "sec-children", label: "6.0 Çocukların Gizliliği" },
        { id: "sec-changes", label: "7.0 Politika Güncellemeleri" },
        { id: "sec-contact", label: "8.0 İletişim Bilgileri" }
      ],
      permissionsTable: {
        headers: ["İzin (Permission)", "Kullanım Amacı"],
        rows: [
          {
            perm: "android.permission.INTERNET",
            purpose: "Google AdMob reklamlarının yüklenmesi ve anlık döviz kuru bilgileri için gereklidir."
          },
          {
            perm: "android.permission.USE_BIOMETRIC / USE_FINGERPRINT",
            purpose: "Uygulama açılışında isteğe bağlı biyometrik kilit koruması sağlamak için kullanılır."
          },
          {
            perm: "android.permission.POST_NOTIFICATIONS",
            purpose: "Kullanıcının belirlediği saatlerde yerel harcama hatırlatmaları göndermek için kullanılır."
          },
          {
            perm: "android.permission.SCHEDULE_EXACT_ALARM",
            purpose: "Sabit fatura ve günlük hatırlatıcıların tam belirlenen zamanda yerel olarak uyarılması için kullanılır."
          },
          {
            perm: "com.google.android.gms.permission.AD_ID",
            purpose: "Google AdMob reklam kimliği (GAID) doğrulaması ve reklam sunumu için kullanılır."
          }
        ]
      },
      table: {
        headers: ["Veri Kategorisi", "Toplanıyor mu?", "Sunucuya Aktarım", "3. Taraf Paylaşımı", "Depolama Yeri"],
        rows: [
          {
            category: "Finansal Kayıtlar & Notlar (Gelir, Gider, Bütçe)",
            collected: "Hayır (Sunucuda)",
            remote: "Sıfır İletim",
            sharing: "Paylaşılmaz / Satılmaz",
            storage: "Yerel SQLite (Cihaz İçi)",
            isLocal: true
          },
          {
            category: "Kişisel Kimlik Bilgileri (Ad, E-posta, Telefon)",
            collected: "Toplanmaz",
            remote: "Yok",
            sharing: "Paylaşılmaz",
            storage: "Hesap Zorunluluğu Yok",
            isLocal: false
          },
          {
            category: "Banka ve Kredi Kartı Bilgileri",
            collected: "Toplanmaz",
            remote: "Yok",
            sharing: "Paylaşılmaz",
            storage: "Talep Edilmez",
            isLocal: false
          },
          {
            category: "Biyometrik Veriler (Face ID / Parmak İzi)",
            collected: "Erişilemez",
            remote: "Yok",
            sharing: "Paylaşılmaz",
            storage: "Yerel İşletim Sistemi (OS Enclave)",
            isLocal: true
          },
          {
            category: "Reklam Kimliği (GAID / Ad ID)",
            collected: "AdMob Tarafından",
            remote: "Google AdMob",
            sharing: "Google Politikaları Uyarınca",
            storage: "Google Sunucuları",
            isLocal: false
          },
          {
            category: "Konum Bilgisi",
            collected: "Yaklaşık (AdMob)",
            remote: "AdMob Servisi",
            sharing: "Google Reklam Ağı",
            storage: "Google Sunucuları",
            isLocal: false
          }
        ]
      },
      contact: {
        app: "Inexo Finance",
        packageId: "com.burakkarahan.inexo",
        developer: "Burak Karahan",
        email: "burakkarahan@inexofinance.com",
        website: "www.devburakkarahan.com",
        labels: {
          app: "Uygulama Adı",
          packageId: "Paket Tanımlayıcı",
          developer: "Geliştirici / Yayıncı",
          email: "İletişim / Destek E-Postası",
          website: "Geliştirici Web Sitesi"
        }
      }
    }
  },
  
  en: {
    navbar: {
      home: "Home",
      experience: "Experience",
      education: "Education",
      projects: "Projects",
      contact: "Contact",
      toggle: "TR"
    },
    hero: {
      greeting: "HELLO, I AM",
      title: "Software Engineer & Backend Developer",
      about: "I develop end-to-end mobile and web applications along with the server infrastructures that power them. By blending software architecture, API design, backend development, and Linux system administration, I oversee the entire technical lifecycle from design to production with an integrated engineering approach. Building high-performance, scalable, and user-centric modern solutions.",
      status_prefix: "Currently working on:",
      status_text: "Spring Boot & Microservices",
      status_suffix: "",
      btn_cv: "Download CV",
      btn_projects: "View Projects"
    },
    sections: {
      skills: "Tech Stack",
      experience: "Work Experience",
      education: "Education",
      projects: "Featured Projects",
      contact_title: "Get in Touch",
      contact_subtitle: "Feel free to contact me for projects, collaboration offers, or just to say hello.",
      contact_form_name: "Full Name",
      contact_form_email: "Email Address",
      contact_form_msg: "Your Message",
      contact_btn: "Send",
      contact_sending: "Sending...",
      contact_sent: "Sent!",
      footer: "© 2026 Burak Karahan. All rights reserved."
    },
    experience: [
      {
        company: "Fibabanka",
        role: "System Administration Intern",
        badge: "Long-Term Internship (6 mos)",
        date: "02/2026 – 07/2026",
        description: "Actively took part in the configuration and operational processes of Red Hat Linux-based servers hosting software architectures. Contributed to system sustainability and resilience by supporting enterprise backup and storage infrastructure management to ensure uninterrupted and secure application operation.",
        tags: ["Red Hat Linux", "System Administration", "Backup & Storage", "Server Operations"]
      },
      {
        company: "Deka Technology",
        role: "Backend Developer Intern",
        badge: "Summer Internship (2 mos)",
        date: "07/2025 – 09/2025",
        description: "Applied software architecture and API development competencies to real-world projects, actively working on backend and database operations. Blended algorithmic foundations with server-side development to directly contribute to building performant and scalable applications.",
        tags: ["Backend Development", "API Design", "Database Operations", "Microservices"]
      }
    ],
    education: [
      {
        school: "Firat University",
        degree: "Bachelor's Degree",
        field: "Software Engineering",
        status: "Graduate",
        gpa: "GPA: 3.31",
        date: "2022 – 2026",
        description: "Graduated with a Bachelor's degree in Software Engineering with a 3.31 GPA. Received comprehensive academic and hands-on training in software architectures, data structures, algorithms, and system design."
      }
    ],
    projects: [
      {
        title: "RepVision",
        date: "11/2025 - Present",
        description: "Built a mobile platform that analyzes exercise videos using Python (pose estimation) and asynchronously manages the video processing pipeline via RabbitMQ. Configured all infrastructure services, including database and message broker, using Docker.",
        tags: ["React Native", "Spring Boot", "RabbitMQ", "Python", "PostgreSQL", "Docker"],
        link: "https://github.com/BurakKarahan8/RepVision",
      },
      {
        title: "Digital Çarşı (E-Commerce Platform)",
        date: "07/2025 - 09/2025",
        description: "Developed a scalable platform featuring JWT authentication, role-based authorization, and email verification, running on an integrated backend and database architecture tailored for real-world scenarios.",
        tags: ["React", "Spring Boot", "PostgreSQL", "Docker", "JWT"],
        link: "https://github.com/BurakKarahan8/DigitalCarsi",
      },
      {
        title: "InternAI",
        date: "02/2025 - 06/2025",
        description: "Developed a comprehensive career platform featuring AI-powered automated CV parsing and internship listings management. Built backend services and system architecture to power both web and mobile components.",
        tags: ["React", "Spring Boot", "PostgreSQL", "AI Parsing"],
        link: "https://github.com/BurakKarahan8/InternAI",
      },
      {
        title: "Renewable Energy Analysis",
        date: "10/2024 - 01/2025",
        description: "Developed a full-stack web application visualizing the geographical distribution of renewable energy sources across Turkey on an interactive map using PostgreSQL data.",
        tags: ["React", "Spring Boot", "PostgreSQL", "Data Vis"],
        link: "https://github.com/BurakKarahan8/Turkey-renewable-energy-analysis",
      }
    ],
    inexoPrivacy: {
      tag: "Official Legal Document",
      printBtn: "Print / PDF",
      title: "Privacy Policy",
      subtitle: "Data Protection & Privacy Policy for Inexo Finance Mobile Application",
      meta: {
        appLabel: "Application",
        appName: "Inexo Finance",
        packageLabel: "Package ID",
        packageId: "com.burakkarahan.inexo",
        developerLabel: "Developer / Publisher",
        developerName: "Burak Karahan",
        updatedLabel: "Effective / Last Updated",
        updatedDate: "October 18, 2026"
      },
      complianceNotice: "This Privacy Policy has been formulated in full compliance with the Google Play Developer Program Policies, Apple App Store Review Guidelines, and applicable international privacy frameworks (GDPR / CCPA). Inexo Finance operates on a 100% offline local storage paradigm for financial data; your income and expense records are never transmitted to any external server.",
      tocTitle: "Table of Contents",
      toc: [
        { id: "sec-overview", label: "1.0 Overview & Core Philosophy" },
        { id: "sec-data", label: "2.0 Collected & Processed Data" },
        { id: "sec-admob", label: "2.1 Advertising Services (Google AdMob)" },
        { id: "sec-permissions", label: "3.0 Permissions & Usage Purposes" },
        { id: "sec-matrix", label: "4.0 Data Safety Disclosure Matrix" },
        { id: "sec-deletion", label: "5.0 Data Security & Deletion Rights" },
        { id: "sec-children", label: "6.0 Children's Privacy" },
        { id: "sec-changes", label: "7.0 Policy Revisions" },
        { id: "sec-contact", label: "8.0 Contact Information" }
      ],
      permissionsTable: {
        headers: ["Permission", "Purpose of Use"],
        rows: [
          {
            perm: "android.permission.INTERNET",
            purpose: "Required for loading Google AdMob advertisements and fetching live exchange rate data."
          },
          {
            perm: "android.permission.USE_BIOMETRIC / USE_FINGERPRINT",
            purpose: "Used to provide optional biometric screen lock protection upon app launch."
          },
          {
            perm: "android.permission.POST_NOTIFICATIONS",
            purpose: "Used to trigger local expense reminders at user-defined intervals."
          },
          {
            perm: "android.permission.SCHEDULE_EXACT_ALARM",
            purpose: "Used to schedule precise local notifications for recurring bills and daily reminders."
          },
          {
            perm: "com.google.android.gms.permission.AD_ID",
            purpose: "Used by Google AdMob to access the Google Advertising ID (GAID) for ad serving and fraud prevention."
          }
        ]
      },
      table: {
        headers: ["Data Category", "Collected on Server?", "Remote Transmission", "Third-Party Sharing", "Storage Location"],
        rows: [
          {
            category: "Financial Records & Notes (Expenses, Income, Budget)",
            collected: "No",
            remote: "Zero",
            sharing: "Never Shared / Sold",
            storage: "Local SQLite (On-Device)",
            isLocal: true
          },
          {
            category: "Personal Identity (Name, Email, Phone)",
            collected: "No",
            remote: "Zero",
            sharing: "Never Shared",
            storage: "No Account Required",
            isLocal: false
          },
          {
            category: "Banking / Card Credentials",
            collected: "No",
            remote: "Zero",
            sharing: "Never Shared",
            storage: "Never Requested",
            isLocal: false
          },
          {
            category: "Biometrics (Face ID / Fingerprint)",
            collected: "Inaccessible",
            remote: "Zero",
            sharing: "Never Shared",
            storage: "Native Device Enclave (OS)",
            isLocal: true
          },
          {
            category: "Advertising Identifier (GAID / Ad ID)",
            collected: "By Google AdMob",
            remote: "Google AdMob",
            sharing: "Per Google Policies",
            storage: "Google Servers",
            isLocal: false
          },
          {
            category: "Location Information",
            collected: "Approximate (AdMob)",
            remote: "AdMob Network",
            sharing: "Google Advertising Network",
            storage: "Google Servers",
            isLocal: false
          }
        ]
      },
      contact: {
        app: "Inexo Finance",
        packageId: "com.burakkarahan.inexo",
        developer: "Burak Karahan",
        email: "burakkarahan@inexofinance.com",
        website: "www.devburakkarahan.com",
        labels: {
          app: "Application",
          packageId: "Package Identifier",
          developer: "Developer / Publisher",
          email: "Contact / Support Email",
          website: "Developer Website"
        }
      }
    }
  }
};